import { createStore } from 'vuex'
import cache from './modules/keepalive'
import user from './modules/user'

export default createStore({
  modules: { cache, user }
})
